
import useTreeNode from '@/composables/useTreeNode'
import { SelectOption } from '@/models/generics'
import _ from 'lodash'
import { defineComponent, ref, Ref, reactive, computed, ComputedRef, toRefs, PropType, watch, onMounted } from 'vue'
import ObjectTreeNode from './ObjectTreeNode.vue'
import Toggle from '@/components/Toggle.vue'

export default defineComponent({
  name: 'ObjectTree',
  components: { ObjectTreeNode, Toggle },
  props: {
    modelValue: {
      type: [Object, Array, String] as PropType<string | Record<string, any> | Array<Record<string, any>>>,
      default: () => ({})
    },
    suggestions: {
      type: Array as PropType<Array<SelectOption>>,
      default: () => ([])
    },
    header: {
      type: String
    },
    label: {
      type: String,
      default: 'Add Node'
    }
  },
  emits: ['update:modelValue', 'node:add', 'node:remove'],
  setup (props, actions) {
    const root = ref(props.modelValue)
    const preview = ref(false)
    const jsonError = ref<string | null>()
    const { state, ...nodeProps } = useTreeNode(props, actions)

    function checkValue (value) {
      if (typeof value === 'string') {
        try {
          const parsed = JSON.parse(value)
          actions.emit('update:modelValue', parsed)
        } catch (e) {
          console.error('ObjectTree | Attempted to parse string input, but failed', e)
        }
      }
    }

    watch(() => props.modelValue, value => {
      checkValue(value)
      root.value = value
    })

    function addRootNode (value = 'enter a value') {
      const key = `field-${Object.keys(root.value).length}`
      // console.log('set root key', key)
      root.value[key] = value

      // const index = state.keyIndex.findIndex(keyIndex => keyIndex.key === key)
      // if (index < 0) state.keyIndex.push({ key, index: state.keyIndex.length })

      actions.emit('node:add', { key, value })
    }

    function updateRoot (e) {
      // console.log('updateRoot', e, root.value)
      actions.emit('update:modelValue', root.value)
    }

    const dbUpdateRoot = _.debounce((e) => {
      if (e.target?.textContent) {
        try {
          const json = JSON.parse(e.target.textContent.trim().replace(/(<([^>]+)>)/gi, ''))
          jsonError.value = null
          root.value = json

          // TODO check json against set type using model corresponding to type
        } catch (error:any) {
          console.error('setting error', error.toString(), '\ninnerHTML: ', e.target.textContent)
          jsonError.value = error.toString()
        }
      }
      updateRoot(e)
    }, 400, { leading: false, trailing: true })

    onMounted(() => {
      checkValue(props.modelValue)
    })

    return {
      ...toRefs(state),
      preview,
      jsonError,
      ...nodeProps,
      addRootNode,
      root,
      updateRoot,
      dbUpdateRoot
    }
  }
})
